// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Card, Grid, Button, Container, Placeholder } from 'semantic-ui-react'
import woo from '../assets/step7.png'
import stor from '../assets/storageph.png'
import Img from 'react-image'

const ImgLoader = (
  <Placeholder fluid style={{ height: 300 }}>
    <Placeholder.Image />
  </Placeholder>
)
export default class Blog extends Component {
  render () {
    return (
      <div className='masterdiv'>
        <div className='overview' style={{ backgroundColor: 'transparent' }}>
          <Container className='mtbs'>
            <h2>Blog</h2>
            <br />
            <Grid stackable relaxed masonry='true' doubling verticalAlign='top'>
              <Grid.Column width={8}>
                <Card fluid padded className='blogpost-card'>
                  <Card.Content>
                    <Img loader={ImgLoader} src={woo} style={{ width: '100%' }} />
                    <div className='mtbs'>
                      <h3>How to create and deploy a WooCommerce store</h3>
                      <p>Learn how you can install WordPress and WooCommerce plugin</p>
                    </div>
                    <Button size='large' href='/blog/woocommerce-tuto' color='black'>
                      Read article
                    </Button>
                  </Card.Content>
                </Card>
              </Grid.Column>
              <Grid.Column width={8}>
                <Card fluid padded className='blogpost-card'>
                  <Card.Content>
                    <Img loader={ImgLoader} src={stor} style={{ width: '100%' }} />
                    <div className='mtbs'>
                      <h3>How to upload a file to Firebase Storage in React</h3>
                      <p>Learn how you can upload and retrieve files using Firebase database</p>
                    </div>
                    <Button size='large' href='/blog/firebase-storage-tuto' color='black'>
                      Read article
                    </Button>
                  </Card.Content>
                </Card>
              </Grid.Column>
            </Grid>
          </Container>
        </div>
      </div>
    )
  }
}
